import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableHtmlEditorForEmailTemplates = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableHtmlEditorForEmailTemplates);
};
